import { useQuery } from '@tanstack/react-query';
import { Calendar, Clock, Check, X, AlertCircle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { supabase } from '@/integrations/supabase/client';

export const LeaveWidget = () => {
  const { data: leaveData, isLoading } = useQuery({
    queryKey: ['leave-widget'],
    queryFn: async () => {
      // TODO: Leave requests table not yet created - temporarily disabled
      return {
        pending: 0,
        approved: 0,
        rejected: 0,
        activeToday: 0,
        upcoming: 0,
        recentRequests: []
      };
    },
    refetchInterval: 60000,
  });

  if (isLoading) {
    return (
      <Card className="p-6 animate-pulse">
        <div className="h-32 bg-muted rounded"></div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <div className="flex items-center gap-3 mb-4">
        <Calendar className="w-6 h-6 text-amber-500" />
        <h3 className="text-lg font-semibold">Leave Requests</h3>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-amber-600">{leaveData?.pending || 0}</div>
          <div className="text-sm text-muted-foreground">Pending</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-red-600">{leaveData?.activeToday || 0}</div>
          <div className="text-sm text-muted-foreground">On Leave Today</div>
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Check className="w-4 h-4 text-green-500" />
            <span className="text-sm">Approved</span>
          </div>
          <Badge variant="default">{leaveData?.approved || 0}</Badge>
        </div>
        
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-blue-500" />
            <span className="text-sm">Upcoming (7 days)</span>
          </div>
          <Badge variant="outline">{leaveData?.upcoming || 0}</Badge>
        </div>

        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <X className="w-4 h-4 text-red-500" />
            <span className="text-sm">Rejected</span>
          </div>
          <Badge variant="secondary">{leaveData?.rejected || 0}</Badge>
        </div>
      </div>

      {leaveData?.recentRequests && leaveData.recentRequests.length > 0 && (
        <div className="mt-4 pt-4 border-t">
          <h4 className="text-sm font-medium mb-2">Recent Requests</h4>
          <div className="space-y-1 max-h-20 overflow-y-auto">
            {leaveData.recentRequests.slice(0, 3).map((request) => (
              <div key={request.id} className="text-xs p-2 bg-muted rounded flex justify-between">
                <span className="capitalize">{request.type} leave</span>
                <Badge variant={
                  request.status === 'pending' ? 'default' : 
                  request.status === 'approved' ? 'default' : 'destructive'
                }>
                  {request.status}
                </Badge>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
};